module.exports = __webpack_public_path__ + "static/media/Rectangle182.f9074dfd.png";